import React from 'react';
import * as R from 'ramda';
import { injectTool } from '../../initializers/injectors';
import SetStateFormat from './component';


const registerSetStateFormat = R.pipeP(
  injectTool('SetStateFormat', ({ instance }) => ({
    type: 'customElement',
    title: 'Set State Format',
    render: () => (
      <SetStateFormat
        annotManager={instance.annotManager}
        instance={instance}
        signers={instance.getSigners()}

      />
    ),
  }))
);


export default registerSetStateFormat;
